import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as S from "./styles";
import * as SH from "../../utils/globalStyles/sheet";
import UserAvatar from "../userAvatar";
import { useUserContext } from "../../contexts/user/userContext";
import { useLogout } from "../../contexts/user/useLogout";
import { copyText, formatCellphone, formatCoins } from "../../utils/user";

interface IModalModalSettings {
  open: boolean;
  onClose: () => void;
}

// Perfil aberto pelo ícone do cabeçalho (bottom sheet)
const ModalSettings: React.FC<IModalModalSettings> = ({ open, onClose }) => {
  const { state } = useUserContext();
  const { user } = state;
  const navigate = useNavigate();
  const logout = useLogout();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!user) return;
    if (await copyText(String(user.code))) {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleEdit = () => {
    onClose();
    navigate("/config");
  };

  const handleLogout = () => {
    onClose();
    logout();
  };

  return (
    <SH.Sheet
      anchor="bottom"
      open={open}
      onOpen={() => undefined}
      onClose={onClose}
      disableSwipeToOpen
    >
      <SH.Handle />
      <S.Content>
        <UserAvatar
          name={user?.name}
          code={user?.code}
          avatar={user?.avatar}
          size={72}
        />
        <S.Name>{user?.name || "-"}</S.Name>
        {user?.userName && <S.Login>@{user.userName}</S.Login>}

        <S.InfoList>
          <S.Row>
            <S.Label>Código</S.Label>
            <S.CodeButton
              type="button"
              onClick={handleCopy}
              aria-label="Copiar código"
            >
              {user?.code ?? "-"}
              {copied ? <S.CopiedIcon /> : <S.CopyIcon />}
            </S.CodeButton>
          </S.Row>
          <S.Row>
            <S.Label>Celular</S.Label>
            <S.Value>{formatCellphone(user?.cellphone) || "-"}</S.Value>
          </S.Row>
          <S.Row>
            <S.Label>Moedas</S.Label>
            <S.Coins>
              <S.CoinIcon />
              {formatCoins(user?.coins)}
            </S.Coins>
          </S.Row>
        </S.InfoList>

        <S.PrimaryButton type="button" onClick={handleEdit}>
          <S.EditIcon />
          Editar perfil
        </S.PrimaryButton>
        <S.LogoutButton type="button" onClick={handleLogout}>
          <S.LogoutIcon />
          Sair do app
        </S.LogoutButton>
      </S.Content>
    </SH.Sheet>
  );
};

export default ModalSettings;
